import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";

import { getPrompts } from "../../../../../Api/services/ai";

import Grid from "../../../../../Components/Grid";
import { Text } from "../../../../../Components/Text";

/**
 * the `value` prop should be an object with the following shape:
 * { promptId: string, version: number } | null
 *
 * @param {Object} props
 * @param {Object | null} props.value
 * @param {Function} props.onChange
 */
export const PromptSelector = (props) => {
	/**
	 * Fetch prompts.
	 */
	const { data, isLoading } = useQuery({
		queryKey: ["ai-prompts"],
		queryFn: () => getPrompts(),
	});

	const prompts = (data ?? []).map((prompt) => ({
		value: prompt._id,
		label: prompt.name,
		versions: prompt.versions,
	}));

	const selectedPrompt = props.value?.promptId ? prompts.find((p) => p.value === props.value.promptId) : null;
	const versionValue = props.value?.version ? { value: props.value.version, label: props.value.version } : null;
	const versionOptions = selectedPrompt
		? Array.from({ length: selectedPrompt.versions }, (_, i) => ({ value: i + 1, label: `${i + 1}` }))
		: [];

	const handleChange = (key, value) => {
		if (key === "prompt") {
			const version = value.versions;
			props.onChange({ promptId: value.value, version: version });
		} else if (key === "version") {
			props.onChange({ promptId: selectedPrompt.value, version: value.value });
		}
	};

	return (
		<Grid gap={24} columns={["1fr", "200px"]}>
			<div>
				<Text variant="caption" weight="bold">
					Prompt Library
				</Text>
				<Select
					value={selectedPrompt}
					onChange={(value) => handleChange("prompt", value)}
					options={prompts}
					isSearchable
					isClearable
					isLoading={isLoading}
					placeholder="Select a prompt"
				/>
			</div>
			<div>
				<Text variant="caption" weight="bold">
					Version
				</Text>
				<Select
					value={versionValue}
					onChange={(value) => handleChange("version", value)}
					options={versionOptions}
					isSearchable
					isClearable
					isLoading={isLoading}
					placeholder="Select version"
				/>
			</div>
		</Grid>
	);
};
